import template from './addAddOnModal.html';
import './addAddOnModal.scss';
import * as _ from 'lodash';

class AddAddOnModalController {
    /* @ngInject */
    constructor($uibModal, dataContext, constants, $log, alertService) {
        this.$modal = $uibModal;
        this.$log = $log;
        this.dataContext = dataContext;
        this.constants = constants;
        this.data = this.config.data;
        this.$close = this.config.close;
        this.$dismiss = this.config.dismiss;
        this.alertService = alertService;
        this.addOnsQuantity = 1;
        this.disableNextButton = false;
        this.isSafetyButtonAddon = false;
        this.isAIDAddon = false;
        this.isAIVideoSearchAddon = false;
        this.listOfAIDAddonServices = [];
    }

    close() {
        this.$dismiss();
    }

    $onInit() {
        if (this.data.isAIVideoSearch) {
            this.isAIVideoSearchAddon = true;
            return;
        }
        if (this.data.addon[0].Name.toLowerCase() == this.constants.AddOns.safetyButton.toLowerCase()) {
            this.safetyButtonAddOn = this.data.addon;
            this.isSafetyButtonAddon = true;
            this.totalRMR = (this.addOnsQuantity * this.safetyButtonAddOn[0].Price).toFixed(2);
        }
        if (this.data.addon[0].Name.toLowerCase() == this.constants.AddOns.AIDAddon.toLowerCase()) {
            this.aidAddons = this.data.addon;
            this.isAIDAddon = true;
            _.forEach(this.aidAddons, (addon) => {
                this.listOfAIDAddonServices.push(
                    {
                        servicePlanName: addon.ServicePlan + ': $' + addon.Price + '/month',
                        price: addon.Price,
                        addonId: addon.AddOnID
                    });
            });
            this.listOfAIDAddonServices.push(
                {
                    servicePlanName: '0 Cameras (Remove)',
                    price: 0.00,
                    addonId: 0
                });
            this.aidAddonServicePlanSelected = this.listOfAIDAddonServices[0];
            this.totalRMR = (this.aidAddonServicePlanSelected.price).toFixed(2);
        }
    }

    calculateRMR() {
        this.totalRMR = (this.addOnsQuantity * this.safetyButtonAddOn[0].Price).toFixed(2);
        if (this.addOnsQuantity == null || this.addOnsQuantity == undefined) {
            this.disableNextButton = true;
        } else {
            this.disableNextButton = false;
        }
    }

    next() {
        this.close();
        if (this.isAIVideoSearchAddon) {
            const modalInstance = this.$modal.open({
                template: '<fp-terms-add-on-modal config="config"></fp-terms-add-on-modal>',
                controller: ($scope) => {
                    'ngInject';
                    $scope.config = {
                        data: {
                            isAIVideoSearch: true,
                            aiVideoSearchAddon: this.data.aiVideoSearchAddon
                        },
                        close: modalInstance.close,
                        dismiss: modalInstance.dismiss
                    };
                },
                size: 'lg'
            });
            modalInstance.result.then(() => {
                this.dataContext.account.setAIVideoSearchAddOns().then((result) => {
                    if (result && result.success) {
                        const successModal = this.$modal.open({
                            template: '<fp-success-add-on-modal config="config"></fp-success-add-on-modal>',
                            controller: ($scope) => {
                                'ngInject';
                                $scope.config = {
                                    data: { aiVideoSearch: true },
                                    close: successModal.close,
                                    dismiss: successModal.dismiss
                                };
                            },
                            size: 'lg'
                        });
                    } else {
                        alert((result && result.message) || 'Error enrolling AI Video Search.');
                    }
                });
            });
        }
        else if (this.isAIDAddon) {
            const modalInstance = this.$modal.open({
                template: '<fp-terms-add-on-modal config="config"></fp-terms-add-on-modal>',
                controller: ($scope) => {
                    'ngInject';
                    $scope.config = {
                        data: {
                            aidAddonServicePlanSelected: this.aidAddonServicePlanSelected
                        },
                        close: modalInstance.close,
                        dismiss: modalInstance.dismiss
                    };
                },
                size: 'lg'
            });
        }
        else {
            const modalInstance = this.$modal.open({
                template: '<fp-enrollment-add-on-modal config="config"></fp-enrollment-add-on-modal>',
                controller: ($scope) => {
                    'ngInject';
                    $scope.config = {
                        data: {
                            safetyButtonAddOn: this.data.safetyButtonAddOn,
                            oldQuantity: this.data.oldQuantity,
                            newQuantity: this.addOnsQuantity
                        },
                        close: modalInstance.close,
                        dismiss: modalInstance.dismiss
                    };
                },
                size: 'lg'
            });
        }        
    }

    onSelect() {
        this.totalRMR = (this.aidAddonServicePlanSelected.price).toFixed(2);
    }
    
}

export default {
    template: template,
    bindings: {
        config: '<',
        addon: '<',
        oldQuantity: '<',
        newQuantity: '<'
    },
    controller: AddAddOnModalController
};